$(function() {
    var $hiddenVehicles = $('.mobile-hidden');
    var $showMore = $('#partial-vehicle-btn');

    $showMore.click(function() {
        if ( $showMore.hasClass('retracted') ) {
            $showMore.removeClass('retracted');
            $showMore.addClass('expanded');
            $showMore.html('Show Less');
            $hiddenVehicles.each(function() {
                $( this ).removeClass('mobile-hidden');
            });
        } else {
            $showMore.removeClass('expanded');
            $showMore.addClass('retracted');
            $showMore.html('Show More');
            $hiddenVehicles.each(function() {
                $( this ).addClass('mobile-hidden');
            });
        }     
    });

});